import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { INGREDIENT_NODE_FRAGMENT } from '../fragments'

const REVERT_REPLACE_INGREDIENT_MUTATION = gql`
  mutation revertReplaceIngredient($replaceToken: String!) {
    revertReplaceIngredient(replaceToken: $replaceToken) {
      results {
        ...IngredientNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${INGREDIENT_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default REVERT_REPLACE_INGREDIENT_MUTATION
